export default __webpack_public_path__ + "static/helena-7c27fbccf57593b11fec09a709bd435e.png";